// SlopeDetailsDialog.tsx — Drain slope specs (sdvar)

import { useState } from 'react';
import DialogBase from './DialogBase';
import { SlotEditor } from './SlotEditor';
import { useShallowStore } from '../store/useStore';
import type { SdVar, SdData } from '../types/panelvar';

const FIELDS = [
  { key: 'mark',     label: 'Mark',     type: 'text'   as const },
  { key: 'x',        label: 'X',        type: 'number' as const, unit: '"' },
  { key: 'y',        label: 'Y',        type: 'number' as const, unit: '"' },
  { key: 'size',     label: 'Bar Size', type: 'text'   as const },
  { key: 'spacing',  label: 'Spacing',  type: 'number' as const, unit: '"', min: 1 },
  { key: 'embedLen', label: 'Embed',    type: 'number' as const, unit: '"', min: 0 },
  { key: 'projLen',  label: 'Proj.',    type: 'number' as const, unit: '"', min: 0 },
];

export default function SlopeDetailsDialog() {
  const { ui, project, updatePanel } = useShallowStore(s => ({
    ui: s.ui, project: s.project, updatePanel: s.updatePanel,
  }));
  const panel = project?.panels.find(p => p.id === ui.activePanelId);
  const [slots, setSlots] = useState<SdVar>(panel?.sdvar ?? []);
  if (!panel) return null;

  return (
    <DialogBase title="Slope Details (4 max)" onOk={() => updatePanel(panel.id, { sdvar: slots })}>
      <SlotEditor<SdData>
        slots={slots}
        fields={FIELDS}
        maxSlots={4}
        onChange={v => setSlots(v)}
        defaultData={() => ({ mark: '', x: 0, y: 0, size: '#5', spacing: 12, embedLen: 12, projLen: 6 })}
        label="Slope"
      />
    </DialogBase>
  );
}

